import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ChangeDetectorRef,
  ViewChild,
} from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import * as NotificationsActions from '@collections/notifications/notifications.actions';
import { Store } from '@ngrx/store';
import { IsMobileViewService } from '@shared/services/is-mobile-view.service';
import { AvatarBackgroundSizes, AvatarShapes } from 'mojo-avatar';

import { Notification, NotificationType } from '@shared/models';
import { Router } from '@angular/router';

@Component({
  selector: 'mojo-notification-item',
  templateUrl: './notification-item.component.html',
  styleUrls: ['./notification-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationItemComponent {
  readonly NotificationType = NotificationType;

  avatarBackground = AvatarBackgroundSizes.cover;
  avatarPhotoShape = AvatarShapes.circle;

  @Input() notification: Notification;

  @ViewChild('trigger') menuTrigger: MatMenuTrigger;

  constructor(
    private store: Store,
    public isMobileViewService: IsMobileViewService,
    private cdf: ChangeDetectorRef,
    private router: Router,
  ) {}

  hideNotification($event, notificationId: number) {
    $event.stopPropagation();
    this.store.dispatch(NotificationsActions.hideNotification({ notificationId }));
    this.closeMenu();
  }

  menuMarkForCheck() {
    this.cdf.markForCheck();
  }

  closeMenu() {
    this.menuTrigger.closeMenu();
  }

  navidateAssign(entityType, id) {
    switch (entityType) {
      case 'CANDIDATE':
        this.router.navigate(['candidates', id, 'details']);
        break;
      case 'JOB':
        this.router.navigate(['/jobs', 'job', id]);
        break;
      case 'TALENT_POOL':
        this.router.navigate(['/talent-pools', id]);
        break;
    }
  }
}
